import { render, staticRenderFns } from "./MySubmit.vue?vue&type=template&id=7a4e3b4c&scoped=true"
import script from "./MySubmit.vue?vue&type=script&lang=js"
export * from "./MySubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4e3b4c",
  null
  
)

export default component.exports